/**
 * Cliente REST del PROYECTO FINAL (M2). Endpoints server-authoritative fuera de
 * sync (mismo patrón que `completion/api.ts` y `assessment/api.ts`): la vista del
 * proyecto final con la rúbrica GATEADA por el servidor (solo publicada), la
 * designación por el autor/manager y la fecha límite por cohorte.
 */
import type { Rubric } from "@space/shared";
import { apiJson } from "@/lib/rest";

export interface RubricView {
  /**
   * Rúbrica (jsonb crudo del servidor; forma `Rubric` de `@space/shared`), o
   * `null` si aún no es visible para el alumno (sin publicar). Pasar por
   * `normalizeRubric` antes de renderizar.
   */
  content: Rubric | null;
  published: boolean;
}

export interface FinalProjectAssignment {
  id: string;
  title: string;
  instructions: string | null;
  kind: string;
  max_score: number;
  submission_type: string;
  single_correction: boolean;
  rubric: RubricView;
}

export interface FinalProjectSubmission {
  id: string;
  body: string | null;
  files: string[];
  submitted_at: string | null;
  late: boolean;
}

export interface FinalProjectGrade {
  score: number | null;
  rubric_scores: Record<string, number> | null;
  feedback: string | null;
  status: string;
  graded_at: string | null;
}

export interface FinalProjectCandidate {
  id: string;
  title: string;
  kind: string;
  is_final_project: boolean;
}

export interface FinalProjectView {
  cohort_id: string;
  course_id: string;
  organization_id: string;
  is_manager: boolean;
  assignment: FinalProjectAssignment | null;
  deadline: string | null;
  server_now: string;
  my_submission: FinalProjectSubmission | null;
  my_grade: FinalProjectGrade | null;
  passed: boolean | null;
  candidates: FinalProjectCandidate[];
}

export function fetchFinalProject(cohortId: string): Promise<FinalProjectView> {
  return apiJson<FinalProjectView>(`/api/cohorts/${cohortId}/final-project`);
}

export interface DesignationInput {
  is_final_project: boolean;
  rubric_published: boolean;
  single_correction: boolean;
}

export function saveDesignation(
  assignmentId: string,
  input: DesignationInput,
): Promise<{ ok: boolean } & DesignationInput> {
  return apiJson(`/api/assignments/${assignmentId}/final-project`, {
    method: "PUT",
    body: JSON.stringify(input),
  });
}

export function saveDeadline(
  cohortId: string,
  dueAt: string | null,
): Promise<{ ok: boolean; due_at: string | null }> {
  return apiJson(`/api/cohorts/${cohortId}/final-project/deadline`, {
    method: "PUT",
    body: JSON.stringify({ due_at: dueAt }),
  });
}
